// extracted by mini-css-extract-plugin
export default {"form":"styles-form_form__rk7ox","container":"styles-form_container__elIp6"};